export default Object.freeze({
  Allow: 'allow',
  Denied: 'denied',
});
